var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategoriaHorticulas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 30V14.5517M15.5 15.5172V21.3103M15.5 15.5172C15.5 13.4687 14.6872 11.504 13.2405 10.0555C11.7938 8.60689 9.83167 7.7931 7.78571 7.7931H2V13.5862C2 15.6348 2.81275 17.5994 4.25946 19.048C5.70617 20.4966 7.66833 21.3103 9.71429 21.3103H15.5M15.5 15.5172H21.2857C23.3317 15.5172 25.2938 14.7035 26.7405 13.2549C28.1872 11.8063 29 9.84167 29 7.7931V2H23.2143C21.1683 2 19.2062 2.81379 17.7595 4.26235C16.3128 5.7109 15.5 7.67557 15.5 9.72414V15.5172ZM15.5 15.5172L23.2143 7.7931M15.5 21.3103L7.78571 13.5862",
    stroke: "#69BF8E",
    strokeWidth: 2.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriaHorticulas);
export default __webpack_public_path__ + "static/media/categoriaHorticulas.57e929413074feffb7367511824d45a8.svg";
export { ForwardRef as ReactComponent };